// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"2141b8b5","709":"9004b55e","884":"f8c2276f"}[chunkId] + ".chunk.js";
};